<template>
  <base-modal
    class="userInfoModal"
    title="请准确填写你的个人信息"
    headImgUrl=""
    :showClose="false"
    cancelText=""
    okText="保存"
    @ok="handleOk"
  >
    <div class="form" slot="content" v-if="form">
      <div class="form-item">
        <label>答题者姓名</label>
        <input
          v-model.trim="form.username"
          type="text"
          placeholder="请输入姓名"
        />
      </div>
      <div class="form-item">
        <label>学校</label>
        <el-select
          v-model="form.schoolId"
          placeholder="请选择学校"
          class="userInfoModal-select"
          filterable
        >
          <el-option :label="item.schoolName" :value="item.id" v-for="(item,index) in schoolList" :key="index" />
        </el-select>
      </div>
      <div class="form-item">
        <label>年级</label>
        <el-select
          v-model="form.grade"
          placeholder="请选择年级"
          class="userInfoModal-select"
          filterable
        >
          <el-option :label="item.label" :value="item.value" v-for="(item,index) in USER_GRADE_MAP" :key="index" />
        </el-select>
      </div>
      <div class="form-item">
        <label>身份证号</label>
        <input
          v-model.trim="form.idCardNo"
          type="text"
          placeholder="请输入身份证号"
        />
      </div>
    </div>
  </base-modal>
</template>

<script>
import { getSchoolList } from '@/api/qzStudent';
import { USER_GRADE_MAP } from '@/common/constant/qz';
import BaseModal from '@/components/baseModal.vue';
import { Select, Option } from 'element-ui';

export default {
  name: 'UserInfoModal',
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    }
  },
  components: {
    BaseModal,
    'el-select': Select,
    'el-option': Option,
  },
  data() {
    return {
      form: null,
      schoolList: [],
      USER_GRADE_MAP: USER_GRADE_MAP,
    };
  },
  created() {
    this.form = {
      username: this.userInfo?.username || '',
      schoolId: this.userInfo?.schoolId || null,
      idCardNo: this.userInfo?.idCardNo || '',
      grade: this.userInfo?.grade || '',
    }
    getSchoolList().then((res) => {
      if (res.code === 200) {
        this.schoolList = (res?.body?.schools || []).filter(item => item.id !== 0);
      }
    })
  },
  methods: {
    handleOk() {
      // 这里可以做校验和提交
      if (!this.form.username || !this.form.schoolId || !this.form.idCardNo || !this.form.grade) {
        this.$message.error('请填写完整信息');
        return;
      }
      // 校验身份证号格式

      // 支持身份证和护照校验
      const idCardReg = /(^\d{15}$)|(^\d{17}([0-9Xx])$)/; // 身份证
      const passportReg = /^[a-zA-Z0-9]{5,}$/; // 简单的护照正则（至少5位字母数字）
      if (!idCardReg.test(this.form.idCardNo) && !passportReg.test(this.form.idCardNo)) {
        this.$message.error('请输入正确的身份证号');
        return;
      }
      // 提交逻辑
      this.$emit('save', {
        ...this.userInfo,
        ...this.form
      });
    },
  },
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 26px;
}
.form-item {
  display: flex;
  align-items: center;
}
.form-item label {
  width: 120px;
  font-weight: bold;
  font-size: 18px;
  color: #1D2129;
}
.form-item input {
  flex: 1;
  padding: 16px 24px;
  border-radius: 24px;
  background: #F5F6F9;
  border: none;
  font-size: 16px;
  outline: none;
  color: #1D2129;
}
.form-item input::placeholder {
  color: #C9CDD4;
}
/* 让 el-select 与 input 保持一致样式 */
.form-item .userInfoModal-select {
  flex: 1;
}
.userInfoModal-select /deep/ .el-input__inner {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  border-radius: 24px;
  background: #F5F6F9;
  border: none;
  font-size: 16px;
  color: #1D2129;
}
.userInfoModal-select /deep/ .el-input__inner::placeholder {
  color: #C9CDD4;
}
.userInfoModal-select /deep/ .el-input.is-focus .el-input__inner,
.userInfoModal-select /deep/ .el-input__inner:focus,
.userInfoModal-select /deep/ .el-input__inner:hover {
  border: none;
  box-shadow: none;
}
</style>
<style lang="less">
  .userInfoModal {
    .base-modal_cnt {
      width: 540px;
      padding: 36px 60px 48px;
    }
    .base-modal_title {
      color: #000000E5;
      font-size: 24px;
      font-weight: 600;
    }
    .base-modal_bd {
      width: 100%;
    }
    .base-modal_btn.btn-ok {
      width: 300px;
    }
  }
</style>